import React, { useEffect } from 'react'
import styled from 'styled-components/macro'
import { useTranslation } from 'react-i18next'
import { Text, Button, Grid, Card, Link } from '@resultadosdigitais/tangram-components'
import { Image } from '@resultadosdigitais/front-hub/react'
import { assembleTrackingParams } from '../../services/utmService/trackingParams'

import RDSMKT from './assets/RDSMKT.svg'
import RDSCRM from './assets/RDSCRM.svg'

const CHOOSE_SIGNUP_RDSMKT_RDSCRM_VIEWED = 'Login: Choose Signup RDSMKT/RDSCRM Viewed'
const RDSM_SIGNUP_DOMAIN = 'https://app.rdstation.com.br/'
const CRM_SIGNUP_DOMAIN = 'https://crm.rdstation.com/'

const StyledText = styled(Text)`
  color: var(--color-primary-70);
`

const StyledTextDescription = styled(Text)`
  text-align: center;
  margin: var(--size-spacing-04) 0;
`
const StyledDivWrapper = styled.div`
  height: 556px !important;
  width: 100%;
`

const StyledColTitle = styled(Grid.Column)`
  max-height: 42px;
  align-items: center;
  margin: var(--size-spacing-06) 0;
  text-align: center;
`

const StyledColCards = styled(Grid.Column)`
  max-height: 342px;
  max-width: fit-content;
  margin: var(--size-spacing-04);
`

const StyledColLink = styled(Grid.Column)`
  max-height: 40px;
  margin-top: var(--size-spacing-09) !important;
  text-align: center;
`

const StyledCard = styled(Card)`
  width: 412px;
  height: 342px !important;
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: column;
  border: none;
`
const StyledImage = styled(Image)`
  margin: var(--size-spacing-06) 0 !important;
  width: 224px !important;
  height: 51px !important;
`
const StyledTitle = styled(Text)`
  width: 328px !important;
  text-align: center;
  margin: 0 auto;

  @media screen and (min-width: 768px) {
    width: 100% !important;
  }
`

const ChooseSignup = ({ onClick, onTrack }) => {
  const { t, i18n } = useTranslation()
  const chooseSignup = true
  const urlRDSM = `${RDSM_SIGNUP_DOMAIN}signup?locale=${i18n.language}&${assembleTrackingParams(chooseSignup)}`
  const urlCRM = `${CRM_SIGNUP_DOMAIN}signup?hl=${i18n.language}&${assembleTrackingParams(chooseSignup)}`

  useEffect(() => {
    onTrack && onTrack(CHOOSE_SIGNUP_RDSMKT_RDSCRM_VIEWED)
  }, [onTrack])

  const redirectToSignup = url => {
    window.location.href = url
  }

  const btnRedirect = url => {
    return (
      <Button kind="danger" onClick={() => redirectToSignup(url)}>
        {t('ChooseSignup.Button')}
      </Button>
    )
  }

  const handleBackButtonClick = event => {
    event.preventDefault()
    onClick()
  }

  return (
    <StyledDivWrapper>
      <Grid>
        <Grid.Row align="center" justify="center">
          <StyledColTitle smallMobile={12}>
            <StyledTitle token={Text.tokens.TEXT_XL_BOLD}> {t('ChooseSignup.Title')}</StyledTitle>
          </StyledColTitle>
          <StyledColCards smallMobile={12} desktop={6}>
            <StyledCard style={{ background: '#cafafc' }}>
              <StyledImage src={RDSMKT} alt="RDSMKT" />
              <StyledTextDescription
                token={Text.tokens.TEXT_MD_BOLD}
                dangerouslySetInnerHTML={{
                  __html: t('ChooseSignup.CardRdsMkt'),
                }}
              />
              {btnRedirect(urlRDSM)}
            </StyledCard>
          </StyledColCards>
          <StyledColCards smallMobile={12} desktop={6}>
            <StyledCard>
              <StyledImage src={RDSCRM} alt="RDSCRM" />
              <StyledTextDescription
                token={Text.tokens.TEXT_MD_BOLD}
                dangerouslySetInnerHTML={{
                  __html: t('ChooseSignup.CardRdsCrm'),
                }}
              />
              {btnRedirect(urlCRM)}
            </StyledCard>
          </StyledColCards>
          <StyledColLink smallMobile={12}>
            <Link href="#" onClick={handleBackButtonClick} removeUnderline>
              <StyledText token={Text.tokens.TEXT_MD_REGULAR}>{t('ChooseSignup.BackButton')}</StyledText>
            </Link>
          </StyledColLink>
        </Grid.Row>
      </Grid>
    </StyledDivWrapper>
  )
}

export default ChooseSignup
